import React from 'react';
import { RankingContext } from '@/context/ranking';

export function useRanking() {
  return React.useContext(RankingContext);
}
